import React from 'react'
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import GoogleMapReact from 'google-map-react';
import { fitBounds } from 'google-map-react/utils';

const GoogleMapConfig = {
  key: google_api_key,
  libraries: 'places',
};

class GoogleMapMarker extends React.Component {

  constructor(props) {
    super()
    this.props = props
    this.select = this.select.bind(this)
  }

  select(index) {
    this.props.selectDropoff(this.props.dropoff, index)
  }

  render() {
    return (
      <div className="marker dropoff" onClick={() => this.select(this.props.index)}>
        <div className="title">{this.props.index >= 0 ? this.props.index + 1 : ""}</div>
      </div>
    )
  }
}

class UserMarker extends React.Component {
  render() {
    return (
      <div className="marker user">
      </div>
    )
  }
}

class GoogleMap extends React.Component {

  constructor(props) {
    super()
    this.props = props
    this.initUser = this.initUser.bind(this)
    this.initBounds = this.initBounds.bind(this)
    this.state = { defaultZoom: 11 }
  }

  componentWillMount() {
    this.initUser()
    this.initBounds()
  }

  initBounds() {
    const bounds = new google.maps.LatLngBounds();

    this.props.dropoff.dropoff_points.forEach(dropoff => {
      const newPoint = new google.maps.LatLng(dropoff.latitude, dropoff.longitude);
      bounds.extend(newPoint);
    });
    const newBounds = {
      ne: {
        lat: bounds.getNorthEast().lat(),
        lng: bounds.getNorthEast().lng()
      },
      sw: {
        lat: bounds.getSouthWest().lat(),
        lng: bounds.getSouthWest().lng()
      }
    };
    const size = {
      width: 468, // Map width in pixels
      height: 380, // Map height in pixels
    };

    const {center, zoom} = fitBounds(newBounds, size)
    this.setState({ defaultCenter: center, zoom: zoom })
  }

  initUser() {
    var geocoder = new google.maps.Geocoder();
    var address = this.props.customer.address.line1 + ", " + this.props.customer.address.zipcode + " " + this.props.customer.address.city
    geocoder.geocode( { 'address': address}, (results, status) => {
      if (status == 'OK') {
        var lat =  parseFloat(results[0].geometry.location.lat())
        var lng =  parseFloat(results[0].geometry.location.lng())
        this.setState({ userLocation: { lat: lat, lng: lng }} )
      }
    });
  }


  render() {
    if (this.props.dropoff != undefined) {
      return (
        <GoogleMapReact
          bootstrapURLKeys={GoogleMapConfig}
          defaultCenter={this.state.defaultCenter}
          center={this.state.center}
          defaultZoom={this.state.defaultZoom}
          zoom={this.state.zoom}
          resetBoundsOnResize={true}
        >
        { this.state.userLocation != undefined ?
            <UserMarker lat={this.state.userLocation.lat} lng={this.state.userLocation.lng} />
            :
            null
        }
        {
          this.props.dropoff.dropoff_points.map((dropoffPoint, index) => (
            <GoogleMapMarker
              key={dropoffPoint.id}
              lat={dropoffPoint.latitude}
              lng={dropoffPoint.longitude}
              dropoff={dropoffPoint}
              index={index}
              selectDropoff={this.props.selectDropoff} />
          ))
        }
        </GoogleMapReact>
      )
    } else {
      return (
        <div className="row spinner">
          <div className="col-12">
             <i className="fa-li fa fa-3x fa-spinner fa-spin"/>
            <h3>{I18n.t('shipbacks.modes.dropoffs.modal.loading')}</h3>
          </div>
        </div>
      )
    }
  }
}

const mapStateToProps = state => ({
  customer: state.shipback.customer,
  dropoff: state.quotes.dropoff,
})

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(GoogleMap)


// WEBPACK FOOTER //
// ./app/javascript/components/components/GoogleMap.jsx